import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=b32fb796&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=b32fb796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32fb796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b32fb796')) {
      api.createRecord('b32fb796', component.options)
    } else {
      api.reload('b32fb796', component.options)
    }
    module.hot.accept("./AgreementModal.vue?vue&type=template&id=b32fb796&scoped=true&", function () {
      api.rerender('b32fb796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modal/AgreementModal.vue"
export default component.exports